import React from 'react';
import styled from 'styled-components';
import Logo from './Logo';
import SettingsButton from './SettingsButton';
import { Flex } from './shared/Flex';
import media from '../style/media';

const Wrapper = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
  min-height: 84px;
  padding: 0 14px;
  box-sizing: border-box;
  z-index: 2;
  box-shadow: 0 2px 8px rgba(40, 52, 70, 0.08);
  border-bottom: 1px solid #efe7d9;
  background: #fff;
  ${media.tablet`
    min-height: 94px;
    padding: 0 24px;
  `}
`;

const RightButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TopBar = ({ onSettingsClick, isMeasuring }) => {
  return (
    <Wrapper>
      <Logo />
      <RightButton>
        <SettingsButton disable={isMeasuring} onClick={onSettingsClick} />
      </RightButton>
    </Wrapper>
  );
};

export default TopBar;
